export default {
  'formandbasic-form.basic.title': '基础表单',
  'formandbasic-form.basic.description':
    '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',

  'formandbasic-form.email.required': '请输入邮箱地址！',
  'formandbasic-form.email.wrong-format': '邮箱地址格式错误！',
  'formandbasic-form.userName.required': '请输入用户名!',
  'formandbasic-form.password.required': '请输入密码！',
  'formandbasic-form.password.twice': '两次输入的密码不匹配!',
  'formandbasic-form.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'formandbasic-form.strength.strong': '强度：强',
  'formandbasic-form.strength.medium': '强度：中',
  'formandbasic-form.strength.short': '强度：太短',
  'formandbasic-form.confirm-password.required': '请确认密码！',
  'formandbasic-form.phone-number.required': '请输入手机号！',
  'formandbasic-form.phone-number.wrong-format': '手机号格式错误！',
  'formandbasic-form.verification-code.required': '请输入验证码！',
  'formandbasic-form.title.required': '请输入标题',
  'formandbasic-form.date.required': '请选择起止日期',
  'formandbasic-form.goal.required': '请输入目标描述',
  'formandbasic-form.standard.required': '请输入衡量标准',

  'formandbasic-form.form.get-captcha': '获取验证码',
  'formandbasic-form.captcha.second': '秒',
  'formandbasic-form.form.optional': '（选填）',
  'formandbasic-form.form.submit': '提交',
  'formandbasic-form.form.save': '保存',
  'formandbasic-form.email.placeholder': '邮箱',
  'formandbasic-form.password.placeholder': '至少6位密码，区分大小写',
  'formandbasic-form.confirm-password.placeholder': '确认密码',
  'formandbasic-form.phone-number.placeholder': '手机号',
  'formandbasic-form.verification-code.placeholder': '验证码',
  'formandbasic-form.title.label': '标题',
  'formandbasic-form.title.placeholder': '给目标起个名字',
  'formandbasic-form.date.label': '起止日期',
  'formandbasic-form.placeholder.start': '开始日期',
  'formandbasic-form.placeholder.end': '结束日期',
  'formandbasic-form.goal.label': '目标描述',
  'formandbasic-form.goal.placeholder': '请输入你的阶段性工作目标',
  'formandbasic-form.standard.label': '衡量标准',
  'formandbasic-form.standard.placeholder': '请输入衡量标准',
  'formandbasic-form.client.label': '客户',
  'formandbasic-form.label.tooltip': '目标的服务对象',
  'formandbasic-form.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'formandbasic-form.invites.label': '邀评人',
  'formandbasic-form.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'formandbasic-form.weight.label': '权重',
  'formandbasic-form.weight.placeholder': '请输入',
  'formandbasic-form.public.label': '目标公开',
  'formandbasic-form.label.help': '客户、邀评人默认被分享',
  'formandbasic-form.radio.public': '公开',
  'formandbasic-form.radio.partially-public': '部分公开',
  'formandbasic-form.radio.private': '不公开',
  'formandbasic-form.publicUsers.placeholder': '公开给',
  'formandbasic-form.option.A': '同事甲',
  'formandbasic-form.option.B': '同事乙',
  'formandbasic-form.option.C': '同事丙',
};
